import "./FeaturedCollections.css";
import { Link } from "react-router-dom";

import collection1 from "../../assets/images/category1.webp";
import collection2 from "../../assets/images/category2.webp";
import collection3 from "../../assets/images/category3.webp";
import collection4 from "../../assets/images/category4.webp";

const collections = [
  {
    id: "paithani",
    title: "Handloom Paithani",
    image: collection1,
  },
  {
    id: "ilkal",
    title: "Ilkal Handloom",
    image: collection2,
  },
  {
    id: "maheshwari",
    title: "Maheshwari",
    image: collection3,
  },
  {
    id: "chanderi",
    title: "Chanderi",
    image: collection4,
  },
];
const FeaturedCollections = () => {
  return (
    <section className="featured-section">

      <div className="container">

        <div className="collection-top">

          <div className="line"></div>

          <span>Traditional Handloom</span>

          <div className="line"></div>

       

        </div>

        <h2 className="collection-title">
          Shop by Weave
          <span className="dot"></span>
        </h2>

       <div className="featured-layout">
  {collections.map((item) => (
    <Link
      key={item.id}
     to={`/shop/${item.id}`}
      className="small-card"
    >
      <img src={item.image} alt={item.title} />

      <div className="overlay">
        <h3>{item.title}</h3>
        <span>Explore Collection →</span>
      </div>
    </Link>
  ))}
</div>

      </div>

    </section>
  );
};

export default FeaturedCollections;